import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from '../../../environment';
import {
  GetSensorActuatorBarnMappingsResponse,
  SensorActuatorBarnMapping,
  UpsertSensorActuatorBarnMappingResponse,
} from '../models/farm-result.model';

@Injectable({
  providedIn: 'root',
})
export class FarmResultService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/flock-registration/secure/sensoractuatorbarnmapping`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public getSensorActuatorBarns(): Observable<SensorActuatorBarnMapping[] | HttpErrorResponse> {
    const rq = this.http.get<GetSensorActuatorBarnMappingsResponse>(this.baseUrl).pipe(
      map((response) => response.sensorActuatorBarnMappings),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<SensorActuatorBarnMapping[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );

    return rq;
  }

  public upsertSensorActuatorBarn(
    sensorActuatorBarn: SensorActuatorBarnMapping,
  ): Observable<UpsertSensorActuatorBarnMappingResponse | HttpErrorResponse> {
    return this.http
      .post<UpsertSensorActuatorBarnMappingResponse>(`${this.baseUrl}`, sensorActuatorBarn, {})
      .pipe(
        map((d) => d),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<UpsertSensorActuatorBarnMappingResponse>{});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
